import React, { useContext } from 'react';
import Overlay from '@/components/atoms/Overlay';
import { StateContext } from '@/state/store';
import DisclaimerText from '@/components/layouts/DisclaimerText';

import './DisclaimerOverlay.scss';

const DisclaimerOverlay = () => {
    const store = useContext(StateContext);
    const { dispatch } = store;
    const { disclaimerOverlayVisible, disclaimerdata } = store.state;

    const hideDisclaimerOverlay = () => {
        dispatch({ type: 'HIDE_DISCLAIMER_OVERLAY' });
    };

    return (
        <div className="DisclaimerOverlay">
            <Overlay open={disclaimerOverlayVisible} onAnimationEndCallback={hideDisclaimerOverlay}>
                <DisclaimerText data={disclaimerdata} />
            </Overlay>
        </div>
    );
};

export default DisclaimerOverlay;
